// src/enums/tradeIn.ts
// A customer submits their own car for evaluation/trade-in via the client
// "Sell / Trade-In Your Car" form. Staff review it here and can convert an
// accepted trade-in directly into a new Car Inventory listing.
import { Timestamp } from 'firebase/firestore';

export const TRADE_IN_STATUSES = ['New Submission', 'Under Review', 'Offer Made', 'Accepted', 'Rejected'] as const;
export type TradeInStatus = typeof TRADE_IN_STATUSES[number];

// Shown only when a submission is rejected — required so the decision is
// auditable and the owner can be given a real reason if they follow up.
export const TRADE_IN_REJECTION_REASONS = [
  'Price Expectation Too High',
  'Vehicle Condition Not as Described',
  'Failed Inspection',
  'Documentation / Ownership Issue',
  'Not a Model We Currently Need',
  'Other',
] as const;
export type TradeInRejectionReason = typeof TRADE_IN_REJECTION_REASONS[number];

export interface TradeInSubmission {
  id?: string;
  ownerName: string;
  ownerPhone: string;
  ownerEmail?: string;
  carMake: string;
  carModel: string;
  carYear: number;
  mileageKm?: number;
  condition?: string;
  registrationNumber?: string;
  askingPrice?: number;
  description?: string;
  images?: string[];
  status: TradeInStatus;
  offeredPrice?: number;
  internalNotes?: string;
  rejectionReason?: TradeInRejectionReason; // set only when status === 'Rejected'
  convertedToCarId?: string; // links to the Car Inventory record created FROM the traded-in vehicle
  appliedToSaleCarId?: string; // set once this trade-in's value has been credited toward a different sale
  createdAt?: Date | Timestamp;
  updatedAt?: Date | Timestamp;
}
